import Marquee from "react-fast-marquee";

const items = ["Corps", "Scène", "Coaching", "Danse contemporaine", "Improvisation", "Comédie musicale"];

export const SiteMarquee = ({ bg = "#C4F4E4" }) => (
  <div className="border-y-2 border-black overflow-hidden" style={{ backgroundColor: bg }} data-testid="marquee-band">
    <Marquee speed={50} gradient={false} className="py-5">
      {items.concat(items).map((t, i) => (
        <span key={i} className="font-display text-5xl md:text-6xl uppercase mx-8 tracking-wide flex items-center gap-8">
          {t}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5Z" />
          </svg>
        </span>
      ))}
    </Marquee>
  </div>
);
